import React from 'react'
import Loading from "../../assets/images/loader.gif"
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const FallBackLoader = ({loaderMessage = false}) => {

	const { i18n } = useTranslation();
	const location = useLocation()

	const getLoadingText = ()=>{
		if(loaderMessage){
			return i18n?.t("common.LOGIN_LOADING")
		}
		else{
			return i18n?.t("common.LOADING")
		}
	}

	return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
        }}
      >
        <img
          src={Loading}
          style={{ height: "12vh", width: "12vh" }}
          className="noki-loader"
          alt="Loading..."
        />
        <br />
        {getLoadingText()}...
      </div>
    </>
  );
}

export default FallBackLoader
